module.exports = __webpack_public_path__ + "static/media/konno-yuuki-lose.f06c8841.png";